import store from '@/store'
export default {
  // 车间型号
  className: 'Pack',
  fields: [
    {
      name: 'name',
      validators: [
        (val) => val ? null : '包装名称不可为空'
      ]
    },
    {
      name: 'price',
      validators: [
        (val) => val >= 0 ? val < 0 : '包装价格不可小于0'
      ]
    }
  ],
  search: [
    'name', 'price'
  ],
  hooks: {
  },
  action: {
    create: store.state.user && store.state.user.authority.allPack.create ? {} : false,
    edit: store.state.user && store.state.user.authority.allPack.edit ? {} : false,
    delete: store.state.user && store.state.user.authority.allPack.del ? {} : false
  }
}
